import React from 'react';
import CTALink from "../../../../ui/CTA/CTALink";
import { BagIcon } from "../../../../ui/Icon";
import styles from './ShoppingBagCounter.module.scss';
const ShoppingBagCounter = ({ shoppingBagItems = 0, productInformation, labels, cartUrl, }) => {
    const quantity = productInformation === null || productInformation === void 0 ? void 0 : productInformation.quantity;
    const updatedQuantityItems = quantity && shoppingBagItems + quantity;
    const itemsInShoppingBag = updatedQuantityItems || shoppingBagItems;
    return (React.createElement(CTALink, { href: cartUrl, className: styles.shoppingBagCta, iconElement: React.createElement(BagIcon, null), iconPosition: "end" }, labels === null || labels === void 0 ? void 0 :
        labels.shoppingBagLabel,
        "(",
        itemsInShoppingBag,
        ")"));
};
export default ShoppingBagCounter;
//# sourceMappingURL=ShoppingBagCounter.js.map